// Mallar template pricing. Fixed one-time price per template (SEK).
export const MALLAR_PRICE_SEK = 99
